import { render, staticRenderFns } from "./BuildDataset.vue?vue&type=template&id=15a907e3&scoped=true"
import script from "./BuildDataset.vue?vue&type=script&lang=js"
export * from "./BuildDataset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a907e3",
  null
  
)

export default component.exports